import templateUrl from 'emun.blog/blog-notify.htm'
import controller from 'emun.blog/blog-notify.controller'

let BlogNotify = {
	bindings: {
	},
	controller,

	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl
	}
}

export default BlogNotify;